import { ActionWithPayload } from "@obg/ngrx-utils";
import { updateState } from "@obg/ngx.global";

import { QUICKLINK_ACTION_TYPE } from "./quicklink.action";
import { Quicklink, QuicklinkState } from "./quicklink.model";

const initialState: QuicklinkState = {
	isBusy: false,
	quicklinks: {},
};

export function quicklinkReducer(state = initialState, action: ActionWithPayload): QuicklinkState {
	switch (action.type) {
		case QUICKLINK_ACTION_TYPE.get: {
			return updateState(state, {
				isBusy: true,
			});
		}
		case QUICKLINK_ACTION_TYPE.getSuccess: {
			return updateState(state, {
				isBusy: false,
				quicklinks: updateState(state.quicklinks, action.payload as Record<string, Quicklink[]>),
			});
		}
		case QUICKLINK_ACTION_TYPE.getFail: {
			return updateState(state, {
				isBusy: false,
			});
		}
		default:
			return state;
	}
}
